<template>
  <div>
    <el-card>
      <div slot="header">{{ $t('createlicense') }}</div>
      <div>
        <el-form :model="license" ref="license" @submit.native.prevent="submit" :rules="rules">
          <el-form-item prop="holder">
            <el-select
              :placeholder="$t('chooselicenseuser')"
              v-model="license.holder"
              filterable
              remote
              clearable
              :remote-method="suggest"
              :loading="loading"
            >
              <el-option
                v-for="user in vUsers"
                :value="user.id"
                :label="user.username"
                :key="user.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="liceseName">
            <el-input v-model="license.name" :placeholder="$t('enterlicencename')"></el-input>
          </el-form-item>
          <el-form-item prop="street">
            <el-input v-model="license.street" :placeholder="$t('enterstreetname')"></el-input>
          </el-form-item>
          <el-form-item prop="houseNumber">
            <el-input v-model="license.houseNumber" :placeholder="$t('enterstreetnumber')"></el-input>
          </el-form-item>
          <el-form-item prop="postCode">
            <el-input v-model="license.postCode" :placeholder="$t('enterpostcode')"></el-input>
          </el-form-item>
          <el-form-item prop="city">
            <el-input v-model="license.city" :placeholder="$t('entercity')"></el-input>
          </el-form-item>
          <el-form-item prop="country">
            <el-input v-model="license.country" :placeholder="$t('entercountry')"></el-input>
          </el-form-item>
          <el-form-item prop="latitude">
            <el-input v-model="license.lat" :placeholder="$t('enterlongitude')"></el-input>
          </el-form-item>
          <el-form-item prop="longitude">
            <el-input v-model="license.lon" :placeholder="$t('enterlatitude')"></el-input>
          </el-form-item>
          <el-row type="flex" justify="end" class="buttons">
            <el-button @click="submit($event)" native-type="submit" type="primary" round>{{$t('create')}}</el-button>
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import env from "@/environments/environment";

export default {
  name: "License",
  data() {
    return {
      rules: {
        holder: [
          {
            required: true,
            message: `${this.$t('chooselicenseuser')}`,
            trigger: "change"
          }
        ],
        // liceseName: [
        //   {
        //     required: true,
        //     message: `${this.$t('enterlicencename')}`,
        //     trigger: "change"
        //   }
        // ],
        street: [
          {
            required: true,
            message: `${this.$t('enterstreetname')}`,
            trigger: "change"
          }
        ],
        houseNumber: [
          {
            required: true,
            message: `${this.$t('enterstreetnumber')}`,
            trigger: "change"
          }
        ],
        postCode: [
          {
            required: true,
            message: `${this.$t('enterpostcode')}`,
            trigger: "change"
          }
        ],
        city: [
          {
            required: true,
            message: `${this.$t('entercity')}`,
            trigger: "change"
          }
        ],
        country: [
          {
            required: true,
            message: `${this.$t('entercountry')}`,
            trigger: "change"
          }
        ],
        // latitude: [
        //   {
        //     required: true,
        //     message: `${this.$t('enterlongitude')}`,
        //     trigger: "change"
        //   }
        // ],
        // longitude: [
        //   {
        //     required: true,
        //     message: `${this.$t('enterlatitude')}`,
        //     trigger: "change"
        //   }
        // ]
      },
      license: {
        holder: null
      },
      vUsers: [],
      users: [],
      loading: false
    };
  },
  methods: {
    suggest(query) {
      this.vUsers = this.users.filter(
        user => user.username.toLowerCase().indexOf(query.toLowerCase()) > -1
      );
    },
    async submit(event) {
      event.preventDefault();
      try {
        await this.$refs.license.validate();
        this.$emit("input", {
          ...this.license,
          holderName: this.users.find(user => user.id == this.license.holder)
            .username,
          name: this.license.name, 
          street: this.license.street,
          houseNumber: this.license.houseNumber,
          postCode: this.license.postCode,
          city: this.license.city,
          country: this.license.country,
          lat: this.license.lat,
          lon: this.license.lon
        });
      } catch (e) {
        console.log("invalid", e);
      }
    }
  },
  created() {
    const getUsers = async () => {
      try {
        const {
          data: { users }
        } = await axios.get(`${env.url}/admin/users`);
        this.users = users;
        this.vUsers = users.slice(0);
      } catch (err) {
        console.error(`Failed: `, err);
      }
    };

    getUsers();
  }
};
</script>

<style lang="scss" scoped>
</style>
